import { Avatar } from '@pocketlaw/tetris';
import { getSearchEntityIcon } from 'app/domains/global-search/utils/getSearchEntityIcon';
export function EntityIcon(props) {
    const { type } = props;
    const icon = getSearchEntityIcon(type);
    return (<Avatar appearance="light" size="sm">
      {icon}
    </Avatar>);
}
